import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { uk } from 'date-fns/locale';
import ScheduleEvent from '../ScheduleEvent/ScheduleEvent';
import { getDaySummary } from '../constants';
import './schedule-day.scss';

/** Скільки подій показуємо в клітинці, решта згортається в «ще N». */
const VISIBLE_LIMIT = 3;

const ScheduleDay = ({ events, date }) => {
  const dayNumber = date.getDate();
  const hidden = events.length - VISIBLE_LIMIT;
  const summary = getDaySummary(events);

  // Коли тип написаний у стрічці з числом, повторювати його в кожній події не треба —
  // подія стискається до одного рядка (прапор, час, ДЗ) і клітинка стає нижчою.
  const compact = Boolean(summary?.typeKey);

  return (
    <div className="schedule-day">
      <div className="schedule-day__head">
        <span className="schedule-day__num">{dayNumber}</span>
        <span className="schedule-day__title">{format(date, 'EEEE, d MMMM', { locale: uk })}</span>

        {summary && (
          <span
            className={`schedule-day__summary ${summary.typeKey ? `schedule-day__summary--${summary.typeKey}` : 'schedule-day__summary--mixed'}`}
          >
            {summary.label}
          </span>
        )}
      </div>

      <div className="schedule-day__events">
        {events.slice(0, VISIBLE_LIMIT).map((event, index) => (
          // GROUP BY у місячному запиті теоретично може дати кілька рядків на один e.id,
          // тому індекс у ключі — захист від дублів.
          <ScheduleEvent key={`${event.id}-${index}`} event={event} compact={compact} />
        ))}
        {hidden > 0 && <span className="schedule-day__more">ще {hidden}</span>}
      </div>
    </div>
  );
};

ScheduleDay.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  // Події вже відібрані на цю дату в schedule-month.component (один useMemo на місяць,
  // а не reduce по всьому масиву в кожній із 42 клітинок).
  events: PropTypes.array,
};

ScheduleDay.defaultProps = {
  events: [],
};

export default ScheduleDay;
